export default __webpack_public_path__ + "static/media/resources-icon-purple.10fb4031.svg";